import { ObjectDetailsContentLayout } from 'framework/ViewTypes/contentLayout';
import { EmployeeLinkWithNameLoading } from 'domain/shared/employee';
import {
  POSITION_FILL_REQUEST_BADGE_STATUS_COLOR,
  POSITION_FILL_REQUEST_STATUS,
  POSITION_FILL_REQUEST_STATUS_LABELS,
} from '../../constants';
import type { PositionFillRequestListItem } from '../../types';
import { getPositionFillRequestHeaderActions } from '../header/headerActions';
import PositionFillRequestDetailsCard from './PositionFillRequestDetailsCard';
import PositionFillRequestTimelinePanel from '../tabs/PositionFillRequestTimelinePanel';
import PositionFillRequestActiveProcesses from '../tabs/PositionFillRequestActiveProcesses';

type PositionFillRequestDetailsContentProps = {
  positionFillRequest?: PositionFillRequestListItem;
  stateOwners?: Array<{ id: string; name?: string }>;
  loading?: boolean;
  error?: Error | null;
  retry?: () => void | Promise<unknown>;
  onUpdated: () => void;
  canUpdate: boolean;
  canCancel: boolean;
  canReview: boolean;
  canActivate: boolean;
  onEdit: () => void;
  onCancel: () => void;
};

const PositionFillRequestDetailsContent = ({
  positionFillRequest,
  stateOwners = [],
  loading,
  error,
  retry,
  onUpdated,
  canUpdate,
  canReview,
  canActivate,
  onEdit,
  onCancel,
  canCancel,
}: PositionFillRequestDetailsContentProps) => (
  <ObjectDetailsContentLayout
    data={positionFillRequest}
    loading={loading}
    error={error}
    retry={retry}
    notFoundMessage="Position fill request not found."
    renderContent={loadedPositionFillRequest => {
      const hasActiveProcesses =
        loadedPositionFillRequest.status === POSITION_FILL_REQUEST_STATUS.REQUESTED ||
        loadedPositionFillRequest.status === POSITION_FILL_REQUEST_STATUS.PENDING;

      return {
        header: {
          title: loadedPositionFillRequest.requestDisplayName,
          badges: [
            {
              id: 'status',
              label: POSITION_FILL_REQUEST_STATUS_LABELS[loadedPositionFillRequest.status],
              color: POSITION_FILL_REQUEST_BADGE_STATUS_COLOR[loadedPositionFillRequest.status],
            },
          ],
          owners: stateOwners,
          renderOwner: owner => <EmployeeLinkWithNameLoading id={owner.id} name={owner.name} defaultValue={owner.id} />,
          // TODO Imlement SLA end date when it is available in the backend
          // slaEndDate: ...,
          actions: getPositionFillRequestHeaderActions(loadedPositionFillRequest.status, {
            canUpdate,
            canCancel,
            onEdit,
            onCancel,
          }),
        },
        leftSide: <PositionFillRequestDetailsCard positionFillRequest={loadedPositionFillRequest} />,
        rightSide: [
          hasActiveProcesses ? (
            <PositionFillRequestActiveProcesses
              key="active-processes"
              positionFillRequest={loadedPositionFillRequest}
              stateOwners={stateOwners}
              onUpdated={onUpdated}
              canReview={canReview}
              canActivate={canActivate}
            />
          ) : null,
          <PositionFillRequestTimelinePanel key="timeline" />,
        ],
      };
    }}
  />
);

export default PositionFillRequestDetailsContent;
